import { render, staticRenderFns } from "./BlogPostSocialShare.vue?vue&type=template&id=52d4f377&scoped=true&"
import script from "./BlogPostSocialShare.vue?vue&type=script&lang=js&"
export * from "./BlogPostSocialShare.vue?vue&type=script&lang=js&"
import style0 from "./BlogPostSocialShare.vue?vue&type=style&index=0&id=52d4f377&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d4f377",
  null
  
)

export default component.exports